import { makeStyles } from '@mui/styles';
import { createStyles } from '@mui/styles';

const useBlockStyles = makeStyles(({ spacing, palette, shadows }) =>
  createStyles({
    panel: {
      position: 'absolute',
      transform: 'translate(-50%, calc(-100% - 8px))',
      zIndex: 1000,
    },
    paper: {
      width: 360,
      padding: 16,
      backgroundColor: palette.mode === 'dark' ? palette.background.paper : '#000',
      color: palette.mode === 'dark' ? palette.text.primary : '#fff',
      borderRadius: 8,
      border:
        palette.mode === 'dark'
          ? `1px solid ${palette.divider}`
          : '1px solid rgba(255,255,255,0.12)',
      boxShadow: palette.mode === 'dark' ? shadows[8] : '0 8px 24px rgba(0,0,0,0.6)',
    },

    modeGroup: {
      '& legend': {
        display: 'none',
      },
      '& #mode': {
        flexDirection: 'row',
        marginTop: `-${spacing(2.5)}`,
      },
    },

    title: { color: '#fff' },

    presetsRow: {
      marginTop: 8,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
    },

    actions: {
      marginTop: 16,
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 8,
      width: '100%',
    },
  })
);

export default useBlockStyles;
